import * as React from "react";
import { FilterExpression } from "Engine/src/Helpers/FilterExpressions/FilterExpression";

import { MultiLineContainer } from "../../../MultiLine/MultiLineContainer";
import { AbsoluteModelPath } from "../../../../../../../Common/ModelPath/ModelPath";
import { FormActionHandler } from "../../../../Internals/FormActionHandlers/FormActionHandler";

import { Table } from "./CrossfitTableBodyMultilineRow.styles";

export interface CrossfitTableBodyMultilineRowProps {
    addButton?: string | boolean;
    bindingPath: AbsoluteModelPath;
    storeFiltersWithinSession?: boolean;
    children: React.ReactNode;
    colgroup: JSX.Element;
    footer?: JSX.Element;
    isList: boolean;
    instancesPerPage: number;
    removeButton: boolean;
    isSticky: boolean;
    onRowClick?: FormActionHandler;
    filteredUniqKey: string;
    defaultFilter?: FilterExpression;
    debounceDisable?: boolean;
    disableScroll?: boolean;
    dynamicHeight: boolean;
}

export function CrossfitTableBodyMultilineRow(props: CrossfitTableBodyMultilineRowProps): JSX.Element {
    return (
        <Table>
            {props.colgroup}
            <MultiLineContainer
                storeFiltersWithinSession={props.storeFiltersWithinSession}
                addButton={props.addButton ?? false}
                bindingPath={props.bindingPath}
                isList={props.isList ?? false}
                instancesPerPage={props.instancesPerPage}
                removeButton={props.removeButton}
                filteredUniqKey={props.filteredUniqKey}
                defaultFilter={props.defaultFilter}
                onRowCLick={props.onRowClick}
                debounceDisable={props.debounceDisable}
                disableScroll={props.disableScroll}
                dynamicHeight={props.dynamicHeight}>
                {props.children}
            </MultiLineContainer>
        </Table>
    );
}
